import { leadForwardingProjectBaseSchema } from "./leadForwardingProjectBaseSchema";
import { z } from "zod";

export const newLeadForwardingProjectSchema = z
  .lazy(() => leadForwardingProjectBaseSchema)
  .and(
    z.object({
      partnerId: z.coerce.string().describe("Sales partner's Partner ID (from BC)"),
      partnerName: z.coerce.string().describe("Sales partner's name (from BC)"),
      ownerEmail: z.coerce
        .string()
        .describe(
          "Email of iLOQ's sales representative linked to the partner (from BC). Might be missing.",
        )
        .optional(),
    }),
  );

export type NewLeadForwardingProject = z.infer<typeof newLeadForwardingProjectSchema>;
